import { currentTechStack } from 'data/techStack'
import React, { FunctionComponent } from 'react'
import DevIcon from './icons/dev-icons'

const TechStack: FunctionComponent = () => {
  return (
    <div>
      <div className="flex flex-wrap">
        {currentTechStack.map((tech) => (
          <div key={tech.id} className="flex items-center justify-center py-2 pr-2 gap-1">
            <DevIcon kind={tech.id} />
            <span className="text-sm xl:text-md text-gray-500 dark:text-gray-300 font-medium">
              {tech.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TechStack
